import React, { useState, useEffect } from 'react';
import { Link, NavLink } from "react-router-dom";
import { Search, Menu, Close } from "@mui/icons-material";
import Logo from '../../assets/logo/logo.png';
import navigationLinks from '../../data/navigation.data';
import routes from "../../routes/routes";

export default function Header() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);

    // Détection du scroll pour ajouter une ombre
    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 10);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
        document.body.style.overflow = !isMenuOpen ? 'hidden' : 'unset';
    };

    const getLinkClass = (isActive, isSpecial = false) => `
        flex items-center px-4 py-3 w-full
        ${isSpecial ? 'bg-greensecondary text-blueprimary' : 'hover:text-gray-200'} 
        ${isActive ? 'font-bold' : ''}
        transition-colors duration-200
    `;

    return (
        <header
            id="main-header"
            className={`bg-blueprimary text-white 2xl:pl-44 2xl:pr-44 sticky top-0 z-40 
                ${isScrolled ? '' : ''}`}
        >
            {/* Barre de navigation principale */}
            <div className="h-16 flex items-center justify-between px-4 lg:px-6">
                {/* Logo - toujours visible */}
                <div className="flex items-center">
                    <Link to={routes.home}>
                        <img src={Logo} alt="Logo Madatlas" className="h-6"/>
                    </Link>
                </div>

                {/* Menu Desktop */}
                <nav className="hidden lg:flex items-center h-full">
                    <div className="flex items-center h-full space-x-1">
                        {navigationLinks.map((link, index) => (
                            <React.Fragment key={index}>
                                {link.name === "Proposer un article" ? (
                                    <NavLink
                                        to={link.href}
                                        className={({ isActive }) =>
                                            `h-full flex items-center px-6 bg-greensecondary text-blueprimary transition-colors ${isActive ? 'font-bold' : ''}`
                                        }
                                    >
                                        {link.name}
                                    </NavLink>
                                ) : (
                                    <>
                                        <NavLink
                                            to={link.href}
                                            className={({ isActive }) =>
                                                `h-full flex items-center px-4 hover:text-gray-200 transition-colors ${isActive ? 'font-bold' : ''}`
                                            }
                                        >
                                            {link.name}
                                        </NavLink>
                                        {index < 3 && (
                                            <span className="text-white/20">|</span>
                                        )}
                                    </>
                                )}
                            </React.Fragment>
                        ))}
                    </div>
                    <NavLink
                        to={routes.search}
                        className={({ isActive }) =>
                            `h-full flex items-center px-6 hover:text-gray-200 transition-colors ${isActive ? 'font-bold' : ''}`
                        }
                    >
                        <Search className="w-5 h-5" />
                    </NavLink>
                </nav>

                {/* Bouton Menu Mobile */}
                <button
                    onClick={toggleMenu}
                    className="lg:hidden p-2 hover:bg-white/10 rounded-full transition-colors"
                    aria-label="Toggle menu"
                >
                    {isMenuOpen ? (
                        <Close className="w-6 h-6" />
                    ) : (
                        <Menu className="w-6 h-6" />
                    )}
                </button>
            </div>

            {/* Menu Mobile Overlay */}
            <div
                className={`fixed inset-0 bg-blueprimary z-50 lg:hidden transition-transform duration-300 ease-in-out ${
                    isMenuOpen ? 'translate-x-0' : 'translate-x-full'
                }`}
            >
                {/* Container du menu mobile */}
                <div className="flex flex-col h-full">
                    {/* Header du menu mobile */}
                    <div className="h-16 flex items-center justify-between px-4">
                        <Link to={routes.home} onClick={toggleMenu}>
                            <img src={Logo} alt="Logo Madatlas" className="h-6"/>
                        </Link>
                        <button
                            onClick={toggleMenu}
                            className="p-2 hover:bg-white/10 rounded-full transition-colors"
                            aria-label="Close menu"
                        >
                            <Close className="w-6 h-6" />
                        </button>
                    </div>

                    {/* Liste des liens */}
                    <nav className="flex-1 overflow-y-auto">
                        <div className="flex flex-col">
                            {/* Liens de navigation standards */}
                            {navigationLinks.map((link) => (
                                <NavLink
                                    key={link.href}
                                    to={link.href}
                                    onClick={toggleMenu}
                                    className={({ isActive }) =>
                                        getLinkClass(isActive, link.name === "Proposer un article")
                                    }
                                >
                                    {link.name}
                                </NavLink>
                            ))}

                            {/* Lien de recherche */}
                            <NavLink
                                to={routes.search}
                                onClick={toggleMenu}
                                className={({ isActive }) =>
                                    getLinkClass(isActive)
                                }
                            >
                                <Search className="w-5 h-5 mr-2" />
                                <span>Rechercher</span>
                            </NavLink>
                        </div>
                    </nav>
                </div>
            </div>
        </header>
    );
}